import { GALLERY_TYPE } from './types';
import { containerClassName } from './classNameStrategies';
import galleryComponentWrapper from './components/GalleryComponentWrapper/gallery-component-wrapper';
import BadPlugin from '../../components/BadPlugin';
var galleryRenderDescriptor = function (externalGalleryComponent) { return ({
    component: externalGalleryComponent
        ? galleryComponentWrapper(externalGalleryComponent)
        : BadPlugin,
    classNameStrategies: {
        container: containerClassName,
    },
}); };
export function typeMapper(externalGalleryComponent) {
    return function () {
        var _a;
        return (_a = {},
            _a[GALLERY_TYPE] = galleryRenderDescriptor(externalGalleryComponent),
            _a);
    };
}
//# sourceMappingURL=typeMapper.js.map